import { AvailableComponents } from "./components/Components";

import "./assets/index.css";

import setStyles from "./utils/setStyles";

import defaultConfig from "./defaultConfig";

import DesignTests from "./DesignTests";

import { ReactComponent as GinasteeLogo } from './assets/logo/partnership.svg'

export default function App() {
  const config = window.pageConfig || defaultConfig;

  setStyles(config);

  document.title = config.title;

  var link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = config.favicon;

  return (
    <>
      {
        config.header && <AvailableComponents.HEADER
          config={config.header}
          mode={config.background.mode}
        />
      }
      <main id="page" className={config.background.mode}>
        {config.sections.map((content, i) => {
          const Component = AvailableComponents[content.type];
          if (!Component) return null;
          return <Component key={"section-" + i} config={content} />;
        })}
        <div className="powered">
          <p>Powered by</p>
          <GinasteeLogo />
        </div>
      </main>
      <img src={config.background.path} className="page-bg-image" />

      {
        config.whatsapp && <AvailableComponents.WHATSAPP_BUTTON
          config={config.whatsapp}
        />
      }
    </>
  );
}
